import React, { useEffect, Fragment } from "react";
import { useConfig } from "../core/config";
import { Heading } from "./heading";
import { Spacer } from "./spacer";
import { Text } from "./text";

export interface HubspotFormProps {
  portalId: string;
  formId: string;
  header?: string;
  showDescription?: boolean;
  inlineMessage?: string;
}

declare global {
  interface Window {
    hbspt: any;
  }
}

function HubspotContactForm(props: HubspotFormProps) {
  const { portalId, formId, header, showDescription, inlineMessage } = props;

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/v2.js";
    document.body.appendChild(script);

    script.addEventListener("load", () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId,
          formId,
          target: "#hubspotForm",
          inlineMessage,
        });
      }
    });
  }, [portalId, formId, inlineMessage]);

  return (
    <Fragment>
      <Heading>{header ? header : "Let's talk"}</Heading>
      {showDescription && (
        <Text>
          We would be happy to provide you with more information and free
          consultation to answer your specific office needs.
        </Text>
      )}
      <Spacer size={16} />
      <div id="hubspotForm"></div>
    </Fragment>
  );
}

function HubspotStagingLetsTalkForm() {
  return (
    <HubspotContactForm
      portalId="20436725"
      formId="37f039b5-81ef-4ed9-9e02-d1632577b4f3"
    />
  );
}

export default function HubspotLetsTalkForm(props: HubspotFormProps) {
  const { portalId, formId, header, showDescription, inlineMessage } = props;
  const config = useConfig();

  if (config.environment !== "production") {
    return <HubspotStagingLetsTalkForm />;
  }

  return (
    <HubspotContactForm
      portalId={portalId}
      formId={formId}
      header={header}
      showDescription={showDescription}
      inlineMessage={inlineMessage}
    />
  );
}
